import { token } from '@zillow/constellation';
import styled from 'styled-components';

export const ZillowNavbarNotification = styled.span`
    display: inline-block;
    color: white;
    background-color: ${token('colors.orange400')};
    min-width: 34px;
    line-height: 20px;
    height: 22px;
    margin: auto;
    border-radius: 12px;
    text-align: center;
    margin-left: 5px;
    padding: 1px 4px 0;
    font-size: 14px;
    flex: 0 0 auto;
`;
